var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera",
    transform: "translate(0.416 0.416)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7426",
    "data-name": "Rectangle 7426",
    width: 21,
    height: 21,
    transform: "translate(-0.416 -0.416)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65180",
    "data-name": "Path 65180",
    d: "M46.151,53.508H33.286A1.286,1.286,0,0,1,32,52.222V43.216a1.286,1.286,0,0,1,1.286-1.286h2.573L37.146,40h5.146l1.286,1.93h2.573a1.286,1.286,0,0,1,1.286,1.286v9.005A1.286,1.286,0,0,1,46.151,53.508Z",
    transform: "translate(-29.427 -36.784)",
    fill: "none",
    stroke: "#7a8797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_629",
    "data-name": "Ellipse 629",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(7.584 7.584)",
    fill: "none",
    stroke: "#7a8797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.d4b30d74b0ea406d52d613e38d6f2557.svg";
export { ForwardRef as ReactComponent };